export const notSchCon = {
    notify_sch: ['notify.sch.con'],
    mpPageReset: ['mp.pageReset'],
    mpAppReset: ['mp.appReset'],
    known_issues: ['notify.known.issues'],
    notify_sch_con: (pageFilter) => [...notSchCon.notify_sch, pageFilter],
};

export const notRelCci = {
    notify_rel: ['notify.rel.cci'],
    notify_rel_top_cat: ['notify.rel.top.cat'],
    notify_rel_cci_ver: (version) => [...notRelCci.notify_rel, version],
    notify_rel_top_cat_ver: (version) => [...notRelCci.notify_rel_top_cat, version],
};
